import React from 'react';
import { Field, change } from 'redux-form';
import Checkbox from 'chameleon/ui-stack/ui/base/checkbox';
import { v4 as uuidv4 } from 'uuid';

const CheckboxFieldWrapper = (WrappedComponent) => (props) => {
  const { name, value, title } = props;

  return (
    <Field
      name={name}
      component={WrappedComponent}
      props={{
        value,
        title,
      }}
    />
  );
};

/**
 * Redux-form wrapper for Checkbox component.
 * */
const CheckboxField = (props) => {
  const {
    input,
    meta: { form, dispatch },
    value,
    title,
  } = props;

  const componentUuid = `checkbox-${uuidv4()}`;

  const handleChange = (newValue) => {
    dispatch(change(form, input.name, newValue));
  };

  return (
    <>
      <div className="h-8 d-flex flex-row items-center mb-0.8">
        <Checkbox
          description={title}
          checked={value}
          onClick={(checked) => handleChange(checked)}
          name={input.name}
          accessibility={{
            'aria-labelledby': componentUuid,
          }}
        />
        <label id={componentUuid} className="ml-0.8 text-base">
          {title}
        </label>
      </div>
    </>
  );
};

CheckboxField.displayName = 'CheckboxField';

export default CheckboxFieldWrapper(CheckboxField);
